// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import App from './App'
import frame from './frame'
import store from './store'

import router from './router'
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import './element-variables.scss'

import './icons' // icon

Vue.use(ElementUI,{locale});
/* eslint-disable no-new */
new Vue({
  el: '#root',
  router,
  store,
  components: { frame },
  template: '<frame/>'
})



// WEBPACK FOOTER //
// ./src/main.js